/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // FIX X ADD CART STICKY

document.addEventListener('DOMContentLoaded', function() {
  const btn = document.querySelector('[data-cart-bar-scroll]');
  if (!btn) return;

  btn.addEventListener('click', function() {
    const waitForDrawer = 150;
    setTimeout(() => {
      const productTitle = document.querySelector('.product__title');
      if (!productTitle) return;

      const header = document.querySelector('.site-header-sticky, .header-sticky, .site-header');
      const headerHeight = header ? header.offsetHeight : 0;

      let OFFSET_EXTRA = window.innerWidth <= 768 ? 75 : 155;

      const targetY = window.scrollY + productTitle.getBoundingClientRect().top - headerHeight - OFFSET_EXTRA;

      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }, waitForDrawer);
  });
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
